/**
 * Created by Vladislav on 18.09.2024.
 */

cleverapps.InitByFeature["energy"] = function (isNewUser) {
    if (connector.platform.oneOf(connector.DIGITAL, connector.DIGITALWEB)) {
        cleverapps.unlimitedLives = new UnlimitedLives();
    }

    LivesHelper.Initialize(isNewUser);

    cleverapps.eventBus.on("pass_level", (isHard) => {
        const game = Game.currentGame;
        const config = isHard ? RewardsConfig.PassHardLevelExpeditionEnergy : RewardsConfig.PassLevelExpeditionEnergy;

        if (!game || !config) {
            return;
        }

        const locationId = LivesHelper.GetActiveOwnLivesLocationId();
        if (locationId === undefined) {
            return;
        }
        game.rewards.expeditionEnergy = config.energy;
    });
};
